import { render, staticRenderFns } from "./LoadingBufferCustom.vue?vue&type=template&id=96c84030"
import script from "./LoadingBufferCustom.vue?vue&type=script&lang=js"
export * from "./LoadingBufferCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports